import { XPorterSchoolModel } from '@/types';
import Axios from 'axios';

const XPorterConfigurationApiUrl = 'xPorterConfiguration';

export const XPorterConfigurationService = {
  async getSchools(): Promise<XPorterSchoolModel[]> {
    const response = await Axios.get(XPorterConfigurationApiUrl);
    return response.data;
  },
  async updateSchool(school: XPorterSchoolModel): Promise<XPorterSchoolModel[]> {
    const response = await Axios.put(XPorterConfigurationApiUrl, school);
    return response.data;
  },
  async addSchool(school: XPorterSchoolModel): Promise<XPorterSchoolModel[]> {
    const response = await Axios.post(XPorterConfigurationApiUrl, school);
    return response.data;
  },
  async deleteSchool(schoolId: number): Promise<XPorterSchoolModel[]> {
    const response = await Axios.delete(`${XPorterConfigurationApiUrl}/${schoolId}`);
    return response.data;
  },
  async testSchool(schoolId: number): Promise<void> {
    const response = await Axios.get(`${XPorterConfigurationApiUrl}/test/${schoolId}`);
  }
};
